import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const permissionModule = async (data) => {
  return await apiCall("get", apiEndPoints.PERMISSION_MODULE);
};

const permissionService = {
  permissionModule,
};

export default permissionService;
